module.exports = __webpack_public_path__ + "img/service2.f8b3d555.png";